export const getUser = (state: any) => state.userReducer;
export const getTool = (state: any) => state.toolReducer;
export const getProject = (state: any) => state.projectReducer;
